/// <reference types="vite-plugin-svgr/client" />
import Logo from "@/assets/logo.svg?react";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
} from "@/pages/home/components/ui/navigation-menu";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { routes } from "@/routes";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

export const Navbar = () => {
  const [top, setTop] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const scrollHandler = () => {
      window.scrollY > 10 ? setTop(false) : setTop(true);
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, [top]);

  return (
    <header
      className={`sticky top-0 z-40 w-full bg-white dark:border-b-slate-700 dark:bg-background transition-shadow ease-out duration-300 ${
        top
          ? `shadow-transparent`
          : `shadow-lg dark:shadow-slate-400/10 shadow-slate-300/30`
      }`}
    >
      <NavigationMenu className="mx-auto">
        <NavigationMenuList className="container h-14 px-4 w-screen flex justify-between">
          <NavigationMenuItem className="font-bold flex">
            <a className="ml-2 font-bold md:text-xl flex" href="/">
              <Logo />
            </a>
          </NavigationMenuItem>

          <div className="flex gap-2 md:gap-4">
            <Button asChild variant="default">
              <Link to={routes.auth.register}>{t("create-menu")}</Link>
            </Button>
          </div>
        </NavigationMenuList>
      </NavigationMenu>
    </header>
  );
};
